import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';

import { ListItem, LookupModel } from 'src/app/models/listItem';
import { SessionService } from './storage/session.service';
import { SessionStatus } from '../constants/session';

const controllerRoute = '/lookups';
/**
   * For ListItem dropdowns use mwp-dropdown and add [isListItemArray] ="true"
   */
@Injectable()

export class LookupService {

    public suffixes: ListItem[];
    public employmentStatus: ListItem[];
    public relationships: ListItem[];
    public beneficiaryRelationships: ListItem[];
    public callLogTypes: ListItem[];
    public scheduledEventTypes: ListItem[];
    public scheduledEventReminders: ListItem[];
    public timeZones: ListItem[];
    public dateRangeTypes: ListItem[];
    public salaryFrequency: ListItem[];
    public activityLogType: ListItem[];
    public federalFilingStatuses: ListItem[];
    public statesWithIncomeTax: ListItem[];

    public sessionStore: Observable<any>;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService,
    ) {
        this.sessionStore = this.sessionService.$SessionClear;
        this.sessionStore.subscribe((status: string) => {
            switch (status) {
                case SessionStatus.clearSession:
                    this.suffixes = null;
                    this.employmentStatus = null;
                    this.relationships = null;
                    this.beneficiaryRelationships = null;
                    this.callLogTypes = null;
                    this.scheduledEventTypes = null;
                    this.scheduledEventReminders = null;
                    this.timeZones = null;
                    this.dateRangeTypes = null;
                    this.salaryFrequency = null;
                    this.activityLogType = null;
                    this.statesWithIncomeTax = null;
                    break;
            }
        });
    }

    public getSuffix(): Observable<ListItem[]> {
        if (this.suffixes)
            return of(this.suffixes);

        return this.apiService.get(`${controllerRoute}/name-suffix`).pipe(
            map((response: LookupModel) => {
                this.suffixes = response.items;
                return response.items;
            }),
        );
    }

    public getRelationships(): Observable<ListItem[]> {
        if (this.relationships)
            return of(this.relationships);

        return this.apiService.get(`${controllerRoute}/relationships`).pipe(
            map((response: LookupModel) => {
                this.relationships = response.items;
                return response.items;
            }),
        );
    }

    public getBeneficiaryRelationships(): Observable<ListItem[]> {
        if (this.beneficiaryRelationships)
            return of(this.beneficiaryRelationships);

        return this.apiService.get(`${controllerRoute}/beneficiary-relationships`).pipe(
            map((response: LookupModel) => {
                this.beneficiaryRelationships = response.items;
                return response.items;
            }),
        );
    }

    public getTransamericaAccident17Relationships(): Observable<ListItem[]> {
        return this.apiService.get(`${controllerRoute}/transamerica-ci-beneficiary-relationships`).pipe(
            map((response: LookupModel) => {
                this.beneficiaryRelationships = response.items;
                return response.items;
            }),
        );
    }

    public getTransamericaAccident18Relationships(): Observable<ListItem[]> {
        return this.apiService.get(`${controllerRoute}/transamerica-ci-18-beneficiary-relationships`).pipe(
            map((response: LookupModel) => {
                this.beneficiaryRelationships = response.items;
                return response.items;
            }),
        );
    }

    public getCallLogTypes(): Observable<ListItem[]> {
        if (this.callLogTypes)
            return of(this.callLogTypes);

        return this.apiService.get(`${controllerRoute}/agent-call-log`).pipe(
            map((response: LookupModel) => {
                this.callLogTypes = response.items;
                return response.items;
            }),
        );
    }

    public getScheduledEventTypes(): Observable<ListItem[]> {
        if (this.scheduledEventTypes)
            return of(this.scheduledEventTypes);

        return this.apiService.get(`${controllerRoute}/agent-scheduled-event-types`).pipe(
            map((response: LookupModel) => {
                this.scheduledEventTypes = response.items;
                return response.items;
            }),
        );
    }

    public getScheduledEventReminders(): Observable<ListItem[]> {
        if (this.scheduledEventReminders)
            return of(this.scheduledEventReminders);

        return this.apiService.get(`${controllerRoute}/agent-scheduled-event-reminders`).pipe(
            map((response: LookupModel) => {
                this.scheduledEventReminders = response.items;
                return response.items;
            }),
        );
    }

    public getTimeZones(): Observable<ListItem[]> {
        if (this.timeZones)
            return of(this.timeZones);

        return this.apiService.get(`${controllerRoute}/timezone`).pipe(
            map((response: LookupModel) => {
                this.timeZones = response.items;
                return response.items;
            }),
        );
    }

    public getDateRangeTypes(): Observable<ListItem[]> {
        if (this.dateRangeTypes)
            return of(this.dateRangeTypes);

        return this.apiService.get(`${controllerRoute}/date-range-types`).pipe(
            map((response: LookupModel) => {
                this.dateRangeTypes = response.items;
                return response.items;
            }),
        );
    }

    public getSalaryFrequencies(): Observable<ListItem[]> {
        if (this.salaryFrequency)
            return of(this.salaryFrequency);

        return this.apiService.get(`${controllerRoute}/salary-frequency`).pipe(
            map((response: LookupModel) => {
                this.salaryFrequency = response.items;
                return response.items;
            }),
        );
    }

    public getActivityLogTypes(): Observable<ListItem[]> {
        if (this.activityLogType)
            return of(this.activityLogType);

        return this.apiService.get(`${controllerRoute}/member-activity-log`).pipe(
            map((response: LookupModel) => {
                this.activityLogType = response.items;
                return response.items;
            }),
        );
    }

    public getFederalFilingStatuses(): Observable<ListItem[]> {
        if (this.federalFilingStatuses)
            return of(this.federalFilingStatuses);

        return this.apiService.get(`${controllerRoute}/federal-filing-status`).pipe(
            map((response: LookupModel) => {
                this.federalFilingStatuses = response.items;
                return response.items;
            }),
        );
    }

    public getStatesWithIncomeTax(): Observable<ListItem[]> {
        if (this.statesWithIncomeTax)
            return of(this.statesWithIncomeTax);

        return this.apiService.get(`${controllerRoute}/states-with-income-tax`).pipe(
            map((response: LookupModel) => {
                this.statesWithIncomeTax = response.items;
                return response.items;
            }),
        );
    }
}
